/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from "react";
import {
  Row,
  Typography,
  Button,
  Card,
  notification,
  Image,
  Empty,
} from "antd";

// Locales
import "dayjs/locale/th";
// import { useHistory } from "react-router-dom";
import { APIEndpointWeb, webapi } from "@client/web";
import Modal from "antd/lib/modal/Modal";
import Checkbox, { CheckboxChangeEvent } from "antd/es/checkbox";
import logo2 from "../../Image/logoFmr2.png";
import { useCookies } from "react-cookie";
import {
  CK_SHARED_TOKEN,
  CK_ACCESS_TOKEN,
  CK_ACCESS_DATA_ROLE
} from "@constant/constant";
import jsPDF from "jspdf";
import { Sarabun } from '../IsurerComponent/fontSarabun';
import { SarabunBold } from './fonsarabunBold';
import { Redirect } from "react-router-dom";

export interface IResTopic {
  hospital_code: string;
  hospital_name: string;
  insurance_agent: string;
  insurance_name: string;
  ref_code: string;
  request_name: string;
  medical_history_id: string;
  id: string;
  request_date: string;
  logo: string;
}

interface IDataConfirmSelect {
  datavalueStep: any;
  getapi: () => void

}

const { Text } = Typography;
const HomeWebConfirmSelectInsurance: React.FC<IDataConfirmSelect> = ({
  datavalueStep, getapi
}): JSX.Element => {
  // const [consentInsurance, setConsentInsurance] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataResMedical, setDataResMedical] = useState<IResTopic>();
  const [checked, setChecked] = useState(false);
  const [disabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [WindowResize, setWindowResize] = useState(Number);
  const [goToPath, setGoToPath] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE
  ]);
  useEffect(() => {
  }, [datavalueStep]);
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, [WindowResize]);
  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };

  // setGoToPath('/send-request');
  const getconsent = async (item: IResTopic) => {
    setDataResMedical(item);
    setIsModalOpen(true);
  };


  const onChangeCheckedConsent = async (datame: any) => {
    setLoading(true);
    const doc = new jsPDF({
      orientation: "portrait",
      format: "a4",
      unit: "px",
      hotfixes: ["px_scaling"],
    });

    doc.addFileToVFS("THSarabunBold.ttf", SarabunBold);
    doc.addFont("THSarabunBold.ttf", "SarabunBold", "normal");
    doc.setFont("SarabunBold", "normal");
    doc.text(`ถ้อยแถลงมอบอำนาจและยินยอมให้เปิดเผยประวัติการรักษา`, 230, 95, {
      maxWidth: 700,
      align: 'justify',
    })
    doc.addFileToVFS("THSarabun.ttf", Sarabun);
    doc.addFont("THSarabun.ttf", "MyFont", "normal");
    doc.setFont("MyFont", "normal");
    doc.text(`
      โดยหนังสือฉบับนี้ ข้าพเจ้า ${datavalueStep.request_name} ยินยอมให้แพทย์หรือโรงพยาบาลหรือสถานพยาบาลใด ๆ ที่ได้ทำ การตรวจรักษาหรือเคยทำการตรวจสุขภาพของข้าพเจ้า/ผู้บาดเจ็บ/ผู้เจ็บป่วย เปิดเผยประวัติการตรวจรักษาหรือ รายละเอียดต่าง ๆ เกี่ยวกับการตรวจรักษาและผลการตรวจสุขภาพให้แก่ ${datavalueStep.insurance_name} และข้าพเจ้าขอมอบ อำนาจให้ ${datavalueStep.insurance_name} หรือผู้ทำการแทนของบริษัทฯ  เป็นผู้รับมอบ อำนาจตามกฎหมายเพื่อดำเนินการติดต่อขอรับประวัติการรักษาดังกล่าวข้างต้นจากแพทย์หรือโรงพยาบาล หรือสถานรักษาพยาบาลใด ๆ ที่ได้ทำการตรวจรักษา หรือเคยทำการตรวจสุขภาพของข้าพเจ้า/ผู้บาดเจ็บ/ผู้เจ็บป่วย เสมือนหนึ่ง ข้าพเจ้าได้กระทำการด้วยตนเองทุกประการ อนึ่ง สำเนารูปถ่ายหรือสำเนาเอกสารของหนังสือฉบับนี้ ให้ถือว่ามีผลบังคับใช้เช่นเดียวกับต้นฉบับทุกประการ 
      ข้าพเจ้ายินยอมให้บริษัทฯ เก็บรวบรวม และใช้ข้อมูลส่วนบุคคล ข้อมูลสุขภาพ ความพิการ ศาสนา เชื้อชาติ ประวัติการรักษา และประวัติการเรียกร้องค่าสินไหมทดแทนของข้าพเจ้าและ/หรือ ผู้ที่อยู่ในอำนาจปกครองของ ข้าพเจ้า (แล้วแต่กรณี) ทั้งที่ให้ไว้ข้างต้นที่มีอยู่แล้วในปัจจุบันและที่จะมีเพิ่มเติมในอนาคตรวมเรียกว่า "ข้อมูลส่วนบุคคลที่มีความอ่อนไหว"รวมถึงยินยอมให้เปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวดังกล่าวตามที่จำเป็น ให้แก่ผู้บริหารพนักงาน และตัวแทนประกันชีวิต หน่วยงานที่มีหน้าที่เกี่ยวข้องกับการ รับ/จ่าย ผลประโยชน์ตาม กรมธรรม์หน่วยงานราชการ หน่วยงานและคณะกรรมการ ที่มีหน้าที่บังคับใช้กฎหมายหรือที่จัดตั้งขึ้น ตามกฏหมายหน่วยงานรัฐ หรือหน่วยงานกำกับดูแลพันธมิตรธุรกิจของบริษัทฯ มูลนิธิและผู้รับจ้างหรือให้บริการแก่ บริษัทฯ เพื่อให้บริษัทฯ บุคคลและหน่วยงานต่าง ๆ ข้างต้น เก็บรวบรวมและใช้ข้อมูลส่วนบุคคล ที่มีความอ่อนไหว ตามที่จำเป็นและตามที่กฏหมายกำหนดเพื่อการขอเอาประกันภัยการพิจารณารับประกันภัยและประวัติการเรียกร้องค่าสินไหมทดแทนการดำเนินการใด ๆ ที่เกี่ยวข้องกับกรมธรรม์ประกันภัยการขอเอาประกันภัยในอนาคต และเพื่อ การใดอันเป็นประโยชน์แก่ผู้เอาประกันภัย
      ข้าพเจ้ารับทราบว่าการไม่ให้ความยินยอม การเปลี่ยนแปลงขอบเขตการให้ความยินยอม การเพิกถอน ความยินยอม การคัดค้านการขอให้ลบหรือทำลายข้อมูลส่วนบุคคล อาจมีผลทำให้บริษัทฯไม่สามารถบริหารจัดการ หรือดำเนินการใด ๆ อันจำเป็นในการทำสัญญาประกันภัยได้ และอาจมีผลกระทบต่อการให้บริการการจ่ายเงินตาม ผลประโยชน์ตามกรมธรรม์และข้าพเจ้าได้ทราบนโยบายความเป็นส่วนตัวของบริษัทฯ ทั้งนี้การที่ข้าพเจ้าแสดงเจตนา โดยทำเครื่องหมาย(เครื่องหมายเช็คถูก) ใน (ช่องสี่เหลี่ยม) นี้ ถือว่าข้าพเจ้าได้ให้ความยินยอมในการเก็บรวบรวมใช้ และเปิดเผยข้อมูลส่วนบุคคลตามที่ได้ระบุไว้ข้างต้นโดยชัดแจ้งแล้วพร้อมทั้งได้ลงลายมือชื่อไว้เป็นหลักฐาน`, 80, 135, {
      maxWidth: 635,
      align: 'justify'
    })
    // doc.save('doc')
    var consentPdfBase64: any = doc.output('datauri')
    const splitConsentPdfBase64 = consentPdfBase64.split(',')[1]
    const dataInsert = {
      document_id: datavalueStep.medical_history_id,
      consent: splitConsentPdfBase64
    };
    try {
      const { data } = await webapi.post(
        `${APIEndpointWeb.PostMedicalHistory}`, dataInsert,//ส่งแบบ body { dataInsert }
        {
          withCredentials: true,
          // headers: { Authorization: `Bearer ${cookies.shared_token}` }
        }
      );
      if (data.result) {
        if (setTimeout(getapi, 1500,)) {
          setIsModalOpen(false)
          setIsModalOpen(false);
        }
        setChecked(false);
      }

    } catch (error) {
      setIsModalOpen(false);
      console.log(error);
    }
  };
  const onChange = (e: CheckboxChangeEvent) => {
    setChecked(e.target.checked);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const label = `${checked ? "ฉันได้อ่านและยินยอมรับข้อกำหนดและเงื่อนไข" : "ฉันได้อ่านและยินยอมรับข้อกำหนดและเงื่อนไข"}${disabled ? "" : ""}`;

  return (
    <div>
      {goToPath ? <Redirect to={'/request-list'} /> : null}
      {WindowResize > 1024 && (
        <div>
          {datavalueStep ? (
            // <Spin tip="กำลังโหลด..." spinning={loading}>
            <Card className="size-18"
              style={{
                boxShadow: " 1px 1px 15px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#fff",
                height: "85%",
                borderRadius: "20px",
                border: "2px solid #147F8B"
              }}>

              <Text>รายละเอียดผู้ขอประวัติการรักษา</Text>
              <br />
              <Text strong>ชื่อ:</Text>{" "}
              <Text>{datavalueStep.request_name}</Text> <br />
              <br />
              <Text>เจ้าหน้าที่ประกัน</Text>
              <br />
              <Text strong>ชื่อ:</Text>{" "}
              <Text>{datavalueStep.insurance_agent}</Text>
              <br />
              <Text strong>Ref Code:</Text>{" "}
              <Text>{datavalueStep.ref_code}</Text>
              <br />
              <br />
              <Text>โรงพยาบาลที่ขอประวัติการรักษา</Text>
              <br />
              <Text strong>{datavalueStep.hospital_name}</Text>
              <br />
              <Text strong>Hospital code:</Text>{" "}
              <Text>{datavalueStep.hospital_code}</Text>
              <br />
              <br />
              <Button
                block
                size="large"
                onClick={() => getconsent(datavalueStep)}
                style={{
                  color: "white",
                  background: "#147F8B",
                  borderRadius: "18px",
                  height: "40px",
                  fontSize: "16px"
                }}
              >
                ยืนยันขอประวัติการรักษา
              </Button>
            </Card>
            // </Spin>
          ) : ''}
        </div>
      )
      }
      <Modal
        className="ant-modal-body"
        style={{ borderRadius: "20px", top: 20 }}
        closable={false}
        visible={isModalOpen}
        onCancel={handleCancel}
        bodyStyle={{ overflowY: "auto" }}
        footer={
          <Row className="p-2 mb-2" gutter={[16, 8]}>
            <Text className="mb-2">
              <Checkbox
                className="color-checkbox"
                checked={checked}
                disabled={disabled}
                onChange={onChange}
              >
                <Text style={{ fontSize: "14px" }}>{label}</Text>
              </Checkbox>
            </Text>
            <Button
              disabled={!checked === true}
              onClick={onChangeCheckedConsent}
              className={!checked === true ? "bg-B5B5B5" : "bg-147F8B"}
              type="primary"
              size="middle"
              style={{
                width: "100%",
                borderRadius: "15px",
                height: "40px",
                fontSize: "18px"
              }}
            >
              ยอมรับ
            </Button>
          </Row>
        }
      >
        <Row
          style={{ justifyContent: " center" }}
          className="mt-4 mb-2 pl-4 pr-4"
        >
          <Image
            alt="lodo"
            src={logo2}
            preview={false}
            style={{
              width: "140px",
              // height: '50px'
            }}
          />
        </Row>
        <div className="font-title">
          <Row
            style={{ justifyContent: " center" }}
            className="mt-3 mb-2 pl-4 pr-4"
          >

            <Typography.Text
              style={{ fontWeight: "bold" }}
              className="size-16"
            >
              ถ้อยแถลงมอบอำนาจและยินยอมให้เปิดเผยประวัติการรักษา
              {/* ยินยอมให้เปิดเผยประวัติการรักษา */}
            </Typography.Text>
          </Row>
          <div
            className="mt-0 mb-3 pl-4 pr-4"
            //style={{ overflow: " scroll", height: "350px" }}
            style={{ overflowY: "scroll", height: "340px" }}
          >
            <Row className="pb-2">
              <Typography.Text
                className="size-15"
                style={{ justifyContent: " center" }}
              >
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;โดยหนังสือฉบับนี้
                ข้าพเจ้า&nbsp;
                <span style={{ fontWeight: "bold" }}>
                  "{datavalueStep.request_name}"{" "}
                </span>
                &nbsp;ยินยอมให้แพทย์หรือโรงพยาบาลหรือสถานพยบาลใดๆ
                ที่ได้ทำการตรวจรักษาหรือเคยทำการตรวจสุขภาพของข้าพเจ้า/ผู้บาดเจ็บ/ผู้เจ็บป่วย
                เปิดเผยประวัติการตรวจรักษา หรือรายละเอียดต่างๆ
                เกี่ยวกับการตรวจรักษาและผลการตรวจสุขภาพให้แก่
                <span style={{ fontWeight: "bold" }}>&nbsp;"{datavalueStep.insurance_name}"&nbsp;</span>และข้าพเจ้าขอมอบอำนาจให้<span style={{ fontWeight: "bold" }}>&nbsp;"{datavalueStep.insurance_name}"&nbsp;</span>หรือผู้ทำการแทนของบริษัทฯ
                เป็นผู้รับมอบอำนาจตามกฎหมายเพื่อดำเนินการติดต่อขอรับประวัติการรักษาดังกล่าวข้างต้นจากแพทย์ หรือโรงพยาบาลหรือสถานรักษาพยาบาลใดๆที่ได้ทำการตรวจรักษาหรือเคยทำการตรวจสุขภาพของข้าพเจ้า/ผู้บาดเจ็บ/ผู้เจ็บป่วย
                เสมือนหนึ่งข้าพเจ้าได้กระทำการด้วยตนเองทุกประการ อนึ่ง สำเนารูปถ่ายหรือสำเนาเอาสารของหนังสือฉบับนี้ ให้ถือว่ามีผลบังคับใช้เช่นเดียวกับต้นฉบับทุกประการ
              </Typography.Text>
            </Row>
            <Row className="pb-2">
              <Typography.Text className="size-15">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ข้าพเจ้ายินยอมให้บริษัทฯ
                เก็บรวบรวม และใช้ข้อมูลส่วนบุคคล ข้อมูลสุขภาพ ความพิการ
                ศาสนา เชื้อชาติ ประวัติการรักษา
                และประวัติการเรียกร้องค่าสินไหมทดแทนของข้าพเจ้าและ/หรือผู้ที่อยู่ในอำนาจปกครองของข้าพเจ้า
                (แล้วแต่กรณี) ทั้งที่ให้ไว้ข้างต้น ที่มีอยู่แล้วในปัจจุบัน
                และที่จะมีเพิ่มเติมในอนาคต (รวมเรียกว่า
                "ข้อมูลส่วนบุคคลที่มีความอ่อนไหว")
                รวมถึงยินยอมให้เปิดเผยข้อมูลส่วนบุคคล
                ที่มีความอ่อนไหวดังกล่าวตามที่จำเป็น ให้แก่ ผู้บริหาร
                พนักงาน และตัวแทนประกันชีวิต
                หน่วยงานที่มีหน้าที่เกี่ยวข้องกับการรับ/จ่ายผลประโยชน์ตามกรมธรรม์
                หน่วยงานราชการ
                หน่วยงานและคณะกรรมการที่มีหน้าที่บังคับใช้กฎหมายหรือที่จัดตั้งขึ้นตามกฏหมาย
                หน่วยงานรัฐหรือหน่วยงานกำกับดูแล พันธมิตรธุรกิจของบริษัทฯ
                มูลนิธิ และผู้รับจ้างหรือให้บริการแก่บริษัทฯ
                เพื่อให้บริษัทฯ บุคคลและหน่วยงานต่างๆ ข้างต้น
                เก็บรวบรวมและใช้ข้อมูลส่วนบุคคลที่มีความอ่อนไหวตามที่จำเป็นและตามที่กฏหมายกำหนด
                เพื่อการขอเอาประกันภัยการพิจารณารับประกันภัย
                และประวัติการเรียกร้องค่านไหมทดแทน การดำเนินการใดๆ
                ที่เกี่ยวข้องกับกรมธรรม์ประกันภัย
                การขอเอาประกันภัยในอนาคตและเพื่อการใด
                อันเป็นประโยชน์แก่ผู้เอาประกันภัย
              </Typography.Text>
            </Row>
            <Row>
              <Typography.Text className="size-15">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ข้าพเจ้ารับทราบว่า
                การไม่ให้ความยินยอม การเปลี่ยนแปลงขอบเขตการให้ความยินยอม
                การเพิกถอนความยินยอม การคัดค้าน
                การขอให้ลบหรือทำลายข้อมูลส่วนบุคคล อาจมีผลทำให้บริษัทฯ
                ไม่สามารถบริหารจัดการหรือดำเนินการใดๆ
                อันจำเป็นในการทำสัญญาประกันภัยได้และอาจมีผลกระทบต่อการให้บริการ
                การจ่ายเงินตามผลประโยชน์ตามกรมธรรม์
                และข้าพเจ้าได้ทราบนโยบายความเป็นส่วนตัวของบริษัทฯ ทั้งนี้
                การที่ข้าพเจ้าแสดงเจตนาโดยทำเครื่องหมาย
                (เครื่องหมายถูกเช็ค) ใน (ช่องสี่เหลี่ยม) นี้
                ถือว่าข้าพเจ้าได้ให้ความยินยอมในการเก็บรวบรวมใช้
                และเปิดเผยข้อมูลส่วนบุคคลตามที่ได้ระบุไว้ข้างต้นโดยชัดแจ้งแล้วพร้อมทั้งได้ลงลายมือชื่อไว้เป็นหลักฐาน
              </Typography.Text>
            </Row>
          </div>
          {/* ))} */}
          <Row className="pl-4">
            <Text style={{ fontWeight: "bold", fontSize: "16px" }}>
              หมายเหตุ:{" "}
              <Text
                style={{
                  color: "#FF0000",
                  fontWeight: "normal",
                  fontSize: "16px"
                }}
              >
                ความยินยอมดังกล่าวอยู่ในช่วงทดสอบ
              </Text>
            </Text>
          </Row>

        </div>

      </Modal>

    </div >
  );
};

export default HomeWebConfirmSelectInsurance;
